import React from 'react';
import '../styles/loader.css'; // Import the CSS for ease of animation

const Loader = () => {
  return (
    <div className="rocket-loader-overlay">
      <div className="rocket-loader">
        <div className="rocket">
          <div className="rocket-extras"></div>
          <div className="jet"><span></span></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
